import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.section`
  padding: 68px 0 80px;

  .cord-cutting {
    &__subtitle {
      margin-bottom: 48px;
    }
  }

  .feature {
    border-radius: 16px;
    padding: 32px 42px;

    ${breakpoints.down('sm')} {
      padding: 32px;
    }

    &__number {
      background-color: ${p => p.theme.palette.home.left};
      color: ${p => p.theme.palette.home.leftText};
      height: 60px;
      width: 60px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 3.5rem;
    }

    &__btn {
      width: 164px;
      padding-right: 1.5rem;
      padding-left: 1.5rem;

      ${breakpoints.down('xs')} {
        width: 100%;
      }
    }

    .MuiGrid-container {
      ${breakpoints.down('sm')} {
        align-items: center;
      }
    }
  }
`;

export default Container;
